import { useMemo } from "react"
import {
  useFetchIntegrationsQuery,
  useGetIntegrationDetailsQuery,
  useGetStatusQuery,
  useFetchBrandsQuery
} from "../../redux/queries"

interface UseIntegrationsPageDataOpts {
  id?: string
  isSuperAdmin: boolean
  orgId?: string
}

export function useIntegrationsPageData(opts: UseIntegrationsPageDataOpts) {
  const queryParams = useMemo(
    () => ({
      limit: 999,
      ...(opts.isSuperAdmin ? {} : { org_id: opts.orgId })
    }),
    [opts.isSuperAdmin, opts.orgId]
  )

  const { data: brands } = useFetchBrandsQuery(queryParams)
  const { data: integrations, isLoading: isLoadingIntegrations } =
    useFetchIntegrationsQuery(queryParams)

  const { data: integration, isLoading: isLoadingIntegration } =
    useGetIntegrationDetailsQuery(opts.id ?? "", {
      skip: !opts.id
    })

  const { data: statusData = [], isLoading: isLoadingStatus } =
    useGetStatusQuery(
      { integrationID: integration?.id ?? "" },
      { skip: !integration?.id }
    )

  return {
    brands,
    integrations,
    integration,
    statusData,
    isLoadingIntegrations,
    isLoadingIntegration,
    isLoadingStatus
  }
}
